// app/not-found.tsx
'use client';

import Link from 'next/link';
import { Box, Typography, Button } from '@mui/material';

export default function NotFound() {
  return (
    <Box
      sx={{
        minHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        px: 2,
      }}
    >
      <Typography variant="h2" color="primary" gutterBottom>
        404 – Page Not Found
      </Typography>
      <Typography variant="body1" sx={{ mb: 4 }}>
        Sorry, the page you are looking for does not exist.
      </Typography>
      <Button
        component={Link}
        href="/"
        variant="contained"
        sx={{ textTransform: 'none', px: 4 }}
      >
        Go back home
      </Button>
    </Box>
  );
}
